import { render, staticRenderFns } from "./CollectionReport.vue?vue&type=template&id=6198ae6c&scoped=true&"
import script from "./CollectionReport.vue?vue&type=script&lang=js&"
export * from "./CollectionReport.vue?vue&type=script&lang=js&"
import style0 from "./CollectionReport.vue?vue&type=style&index=0&id=6198ae6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6198ae6c",
  null
  
)

export default component.exports